/* Trimleaf widget scripts -- auto-bundled. Do not edit manually. */


/* Widget: dehumidifier-sizing */
(function() {
  "use strict";

  var canopyEl = document.getElementById("tlw_dehum_canopy");
  var stageEl = document.getElementById("tlw_dehum_stage");
  var tempEl = document.getElementById("tlw_dehum_temp");
  var sealedEl = document.getElementById("tlw_dehum_sealed");
  var pintsEl = document.getElementById("tlw_dehum_pints");
  var rangeEl = document.getElementById("tlw_dehum_range");
  var bucketEl = document.getElementById("tlw_dehum_bucket");
  var recsEl = document.getElementById("tlw_dehum_recs");
  var noteEl = document.getElementById("tlw_dehum_note");

  if (!canopyEl || !pintsEl) return;

  var PRODUCTS = [
    { handle: "ac-infinity-hydrone-3-plant-dehumidifier", name: "AC Infinity Hydrone 3", pints: 4 },
    { handle: "ac-infinity-hydrone-5-plant-dehumidifier", name: "AC Infinity Hydrone 5", pints: 7 },
    { handle: "ac-infinity-hydrone-7-plant-dehumidifier", name: "AC Infinity Hydrone 7", pints: 11 },
    { handle: "vivosun-aerodrain-d12-intelligent-environmental-dehumidifier", name: "Vivosun AeroDrain D12", pints: 25 },
    { handle: "ideal-air-50-pint-dehumidifier", name: "Ideal-Air 50 Pint", pints: 50 },
    { handle: "anden-a70-dehumidifier", name: "Anden A70", pints: 70 },
    { handle: "quest-100-dehumidifier", name: "Quest 100", pints: 100 },
    { handle: "anden-a100-dehumidifier", name: "Anden A100", pints: 96 },
    { handle: "anden-a130-dehumidifier", name: "Anden A130", pints: 130 },
    { handle: "quest-155-dehumidifier", name: "Quest 155", pints: 155 },
    { handle: "ideal-air-pro-series-dehumidifier-180-pints", name: "Ideal-Air Pro 180", pints: 180 },
    { handle: "anden-a210v1-dehumidifier", name: "Anden A210 V1", pints: 210 },
    { handle: "quest-next-gen-225", name: "Quest 225", pints: 225 },
    { handle: "anden-a320v3-dehumidifier", name: "Anden A320 V3", pints: 320 },
    { handle: "quest-335-dehumidifier", name: "Quest 335", pints: 345 },
    { handle: "quest-506-dehumidifier-208-230v", name: "Quest 506", pints: 506 },
    { handle: "anden-a710v3-dehumidifier", name: "Anden A710 V3", pints: 710 },
    { handle: "quest-746-industrial-dehumidifier", name: "Quest 746", pints: 746 }
  ];

  function bucketLabel(pints) {
    if (pints < 15) return "Compact tent";
    if (pints < 35) return "Small tent";
    if (pints < 75) return "Medium room";
    if (pints < 150) return "Large room";
    if (pints < 300) return "Commercial";
    return "Industrial";
  }

  function tempMultiplier(temp) {
    if (temp < 65) return 1.4;
    if (temp < 70) return 1.15;
    if (temp <= 85) return 1.0;
    return 1.1;
  }

  function findPicks(target) {
    var below = PRODUCTS.filter(function(p) { return p.pints <= target * 1.05; }).slice(-2);
    var above = PRODUCTS.filter(function(p) { return p.pints > target; }).slice(0, 2);
    var combined = below.concat(above);
    var seen = {};
    var out = [];
    for (var i = 0; i < combined.length && out.length < 3; i++) {
      if (!seen[combined[i].handle]) {
        seen[combined[i].handle] = true;
        out.push(combined[i]);
      }
    }
    if (out.length < 3) {
      for (var j = PRODUCTS.length - 1; j >= 0 && out.length < 3; j--) {
        if (!seen[PRODUCTS[j].handle]) {
          seen[PRODUCTS[j].handle] = true;
          out.push(PRODUCTS[j]);
        }
      }
    }
    return out.sort(function(a, b) { return a.pints - b.pints; });
  }

  function clearChildren(el) {
    while (el.firstChild) el.removeChild(el.firstChild);
  }

  function formatPrice(cents) {
    var n = parseInt(cents, 10);
    if (isNaN(n)) return "";
    return "$" + (n / 100).toFixed(2);
  }

  var productCache = {};
  var pendingFetches = {};

  function fetchProduct(handle) {
    if (productCache[handle] !== undefined) {
      return Promise.resolve(productCache[handle]);
    }
    if (pendingFetches[handle]) return pendingFetches[handle];
    pendingFetches[handle] = fetch("/products/" + handle + ".js", { credentials: "same-origin" })
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(data) {
        productCache[handle] = data || null;
        delete pendingFetches[handle];
        return data || null;
      })
      .catch(function() {
        productCache[handle] = null;
        delete pendingFetches[handle];
        return null;
      });
    return pendingFetches[handle];
  }

  function buildCard(pick) {
    var li = document.createElement("li");
    li.className = "tlw_dehum_rec";

    var link = document.createElement("a");
    link.className = "tlw_dehum_rec_link";
    link.href = "/products/" + pick.handle;

    var imgWrap = document.createElement("div");
    imgWrap.className = "tlw_dehum_rec_img_wrap";
    var imgPlaceholder = document.createElement("div");
    imgPlaceholder.className = "tlw_dehum_rec_img_placeholder";
    imgPlaceholder.textContent = pick.name;
    imgWrap.appendChild(imgPlaceholder);

    var info = document.createElement("div");
    info.className = "tlw_dehum_rec_info";

    var title = document.createElement("div");
    title.className = "tlw_dehum_rec_title";
    title.textContent = pick.name;

    var meta = document.createElement("div");
    meta.className = "tlw_dehum_rec_meta";
    var spec = document.createElement("span");
    spec.className = "tlw_dehum_rec_spec";
    spec.textContent = pick.pints + " pints/day";
    var priceSlot = document.createElement("span");
    priceSlot.className = "tlw_dehum_rec_loading";
    priceSlot.textContent = "Loading";

    meta.appendChild(spec);
    meta.appendChild(priceSlot);
    info.appendChild(title);
    info.appendChild(meta);
    link.appendChild(imgWrap);
    link.appendChild(info);
    li.appendChild(link);

    fetchProduct(pick.handle).then(function(product) {
      if (product) {
        if (product.title) title.textContent = product.title;
        if (product.featured_image) {
          var img = document.createElement("img");
          img.className = "tlw_dehum_rec_img";
          img.loading = "lazy";
          img.alt = product.title || pick.name;
          var src = product.featured_image;
          img.src = src.indexOf("//") === 0 ? "https:" + src : src;
          clearChildren(imgWrap);
          imgWrap.appendChild(img);
        }
        clearChildren(meta);
        meta.appendChild(spec);
        if (product.available === false) {
          var unavail = document.createElement("span");
          unavail.className = "tlw_dehum_rec_unavailable";
          unavail.textContent = "Sold out";
          meta.appendChild(unavail);
        } else if (product.price) {
          var priceWrap = document.createElement("span");
          if (product.compare_at_price && parseInt(product.compare_at_price, 10) > parseInt(product.price, 10)) {
            var compare = document.createElement("span");
            compare.className = "tlw_dehum_rec_price_sale";
            compare.textContent = formatPrice(product.compare_at_price);
            priceWrap.appendChild(compare);
          }
          var price = document.createElement("span");
          price.className = "tlw_dehum_rec_price";
          price.textContent = formatPrice(product.price);
          priceWrap.appendChild(price);
          meta.appendChild(priceWrap);
        }
      } else {
        clearChildren(meta);
        meta.appendChild(spec);
        var viewLink = document.createElement("span");
        viewLink.className = "tlw_dehum_rec_spec";
        viewLink.textContent = "View";
        meta.appendChild(viewLink);
      }
    });

    return li;
  }

  function calculate() {
    var canopy = parseFloat(canopyEl.value) || 16;
    var stage = parseFloat(stageEl.value) || 1.5;
    var temp = parseFloat(tempEl.value) || 78;
    var sealed = parseFloat(sealedEl.value) || 1.0;

    var basePints = canopy * 0.4;
    var stagePints = basePints * (stage / 1.5);
    var tempAdj = stagePints * tempMultiplier(temp);
    var finalPints = tempAdj * sealed;

    var rounded = Math.round(finalPints);
    var low = Math.max(1, Math.round(finalPints * 0.85));
    var high = Math.round(finalPints * 1.15);

    pintsEl.textContent = rounded;
    rangeEl.textContent = "Range " + low + " to " + high + " pints per day";
    bucketEl.textContent = bucketLabel(rounded);

    var picks = findPicks(rounded);
    clearChildren(recsEl);
    picks.forEach(function(p) {
      recsEl.appendChild(buildCard(p));
    });

    var notes = [];
    if (temp < 65) notes.push("Below 65 °F most refrigerant units lose efficiency. Consider a Quest Hi-E Dry series or a desiccant unit.");
    if (sealed > 1.0 && rounded >= 150) notes.push("Sealed rooms this size need redundant capacity. Run two smaller units instead of one large unit for failure protection.");
    if (canopy >= 200 && rounded < 100) notes.push("Your stage selection is producing a low load for a large room. Recalculate at peak flower for worst-case sizing.");

    clearChildren(noteEl);
    if (notes.length) {
      var strong = document.createElement("strong");
      strong.textContent = "Note";
      noteEl.appendChild(strong);
      noteEl.appendChild(document.createTextNode(notes.join(" ")));
    }
  }

  canopyEl.addEventListener("change", calculate);
  stageEl.addEventListener("change", calculate);
  tempEl.addEventListener("input", calculate);
  sealedEl.addEventListener("change", calculate);

  calculate();
})();


/* Widget: ppfd-calculator */
(function() {
  "use strict";

  var C = document.getElementById("tlw_ppfd_container");
  if (!C) return;

  var tabs = C.querySelectorAll(".tlw_ppfd_tab");
  var panels = C.querySelectorAll(".tlw_ppfd_panel");

  // Tab 1
  var ppfIn = document.getElementById("tlw_ppfd_ppf");
  var area1In = document.getElementById("tlw_ppfd_area1");
  var r1 = document.getElementById("tlw_ppfd_r_ppf2ppfd");

  // Tab 2
  var ppfdIn = document.getElementById("tlw_ppfd_ppfd_in");
  var photoSlider = document.getElementById("tlw_ppfd_photo_slider");
  var photoNum = document.getElementById("tlw_ppfd_photo_num");
  var r2 = document.getElementById("tlw_ppfd_r_ppfd2dli");

  // Tab 3
  var luxIn = document.getElementById("tlw_ppfd_lux");
  var luxSrc = document.getElementById("tlw_ppfd_lux_src");
  var r3 = document.getElementById("tlw_ppfd_r_lux2ppfd");

  // Tab 4
  var parIn = document.getElementById("tlw_ppfd_par_w");
  var effIn = document.getElementById("tlw_ppfd_eff");
  var area2In = document.getElementById("tlw_ppfd_area2");
  var r4 = document.getElementById("tlw_ppfd_r_par2ppfd");

  // Tab 5
  var fcIn = document.getElementById("tlw_ppfd_fc");
  var fcSrc = document.getElementById("tlw_ppfd_fc_src");
  var r5 = document.getElementById("tlw_ppfd_r_fc2ppfd");

  if (!ppfIn || !r1) return;

  // Area unit state (synced across tabs)
  var areaUnits = { area1: "ft2", area2: "ft2" };
  var areaDefaults = { ft2: { area1: 16, area2: 16 }, m2: { area1: 1.49, area2: 1.49 } };

  function getAreaM2(inputEl, areaKey) {
    var val = parseFloat(inputEl.value) || 0;
    return areaUnits[areaKey] === "ft2" ? val * 0.0929 : val;
  }

  // Tab switching
  function switchTab(tabId) {
    tabs.forEach(function(t) { t.classList.toggle("tlw_ppfd_active", t.getAttribute("data-tab") === tabId); });
    panels.forEach(function(p) { p.classList.toggle("tlw_ppfd_visible", p.id === "tlw_ppfd_p_" + tabId); });
  }
  tabs.forEach(function(t) { t.addEventListener("click", function() { switchTab(t.getAttribute("data-tab")); }); });

  // Area unit toggles (synced)
  C.querySelectorAll(".tlw_ppfd_unit_toggle").forEach(function(toggle) {
    var areaKey = toggle.getAttribute("data-area");
    toggle.querySelectorAll(".tlw_ppfd_unit_btn").forEach(function(btn) {
      btn.addEventListener("click", function() {
        var newUnit = btn.getAttribute("data-unit");
        if (areaUnits[areaKey] === newUnit) return;
        areaUnits.area1 = newUnit;
        areaUnits.area2 = newUnit;
        C.querySelectorAll(".tlw_ppfd_unit_toggle").forEach(function(tg) {
          tg.querySelectorAll(".tlw_ppfd_unit_btn").forEach(function(b) {
            b.classList.toggle("tlw_ppfd_unit_active", b.getAttribute("data-unit") === newUnit);
          });
        });
        area1In.value = areaDefaults[newUnit].area1;
        area2In.value = areaDefaults[newUnit].area2;
        calcAll();
      });
    });
  });

  // Photoperiod slider/number sync
  photoSlider.addEventListener("input", function() { photoNum.value = photoSlider.value; calcAll(); });
  photoNum.addEventListener("input", function() {
    var v = parseInt(photoNum.value, 10);
    if (v < 1) v = 1; if (v > 24) v = 24;
    photoSlider.value = v; calcAll();
  });

  // Calculations
  function fmt(n) { return n >= 1000 ? n.toLocaleString("en-US", { maximumFractionDigits: 1 }) : n.toFixed(1); }

  function calcAll() {
    // Tab 1: PPF to PPFD
    var ppf = parseFloat(ppfIn.value) || 0;
    var a1 = getAreaM2(area1In, "area1");
    r1.textContent = a1 > 0 ? fmt(ppf / a1) : "---";

    // Tab 2: PPFD to DLI
    var ppfd = parseFloat(ppfdIn.value) || 0;
    var hours = parseFloat(photoSlider.value) || 0;
    r2.textContent = (ppfd * hours * 3600 / 1000000).toFixed(2);

    // Tab 3: Lux to PPFD
    var lux = parseFloat(luxIn.value) || 0;
    r3.textContent = fmt(lux * (parseFloat(luxSrc.value) || 0));

    // Tab 4: PAR to PPFD
    var watts = parseFloat(parIn.value) || 0;
    var eff = parseFloat(effIn.value) || 0;
    var a2 = getAreaM2(area2In, "area2");
    r4.textContent = a2 > 0 ? fmt(watts * eff / a2) : "---";

    // Tab 5: FC to PPFD
    var fc = parseFloat(fcIn.value) || 0;
    r5.textContent = fmt(fc * 10.764 * (parseFloat(fcSrc.value) || 0));
  }

  // Bind live input events
  [ppfIn, area1In, ppfdIn, luxIn, luxSrc, parIn, effIn, area2In, fcIn, fcSrc].forEach(function(el) {
    if (!el) return;
    el.addEventListener("input", calcAll);
    if (el.tagName === "SELECT") el.addEventListener("change", calcAll);
  });

  calcAll();
})();


/* Widget: trimmer-roi */
(function() {
  "use strict";

  var ids = ["harvest", "cycles", "crew", "rate", "handrate", "machine"];
  var els = {};
  for (var i = 0; i < ids.length; i++) {
    els[ids[i]] = document.getElementById("tlw_roi_" + ids[i]);
  }
  var handCostEl = document.getElementById("tlw_roi_hand_cost");
  var machineCostEl = document.getElementById("tlw_roi_machine_cost");
  var savingsEl = document.getElementById("tlw_roi_savings");
  var paybackEl = document.getElementById("tlw_roi_payback");
  var noteEl = document.getElementById("tlw_roi_note");

  if (!els.harvest || !handCostEl) return;

  function fmt(n) {
    if (isNaN(n) || !isFinite(n)) return "--";
    return "$" + Math.round(n).toLocaleString("en-US");
  }

  function calculate() {
    var harvestSize = parseFloat(els.harvest.value) || 0;
    var cycles = parseFloat(els.cycles.value) || 1;
    var crew = parseFloat(els.crew.value) || 1;
    var rate = parseFloat(els.rate.value) || 0;
    var handRate = parseFloat(els.handrate.value) || 0.1;
    var machinePrice = parseFloat(els.machine.value) || 0;

    var annualLbs = harvestSize * cycles;
    var handHours = annualLbs / (handRate * crew);
    var annualHandCost = handHours * rate * crew;

    var machineRate = handRate * 15;
    var machineHours = annualLbs / machineRate;
    var annualMachineCost = machineHours * rate * 1;

    var annualSavings = annualHandCost - annualMachineCost;

    var savingsPerHarvest = annualSavings / cycles;
    var paybackHarvests = savingsPerHarvest > 0 ? machinePrice / savingsPerHarvest : Infinity;
    var paybackMonths = cycles > 0 ? paybackHarvests * (12 / cycles) : Infinity;

    handCostEl.textContent = fmt(annualHandCost);
    machineCostEl.textContent = fmt(annualMachineCost);
    savingsEl.textContent = fmt(annualSavings);

    // Payback badge
    paybackEl.className = "tlw_roi_payback_badge";
    if (annualSavings <= 0 || !isFinite(paybackMonths)) {
      paybackEl.textContent = "No savings";
      paybackEl.classList.add("tlw_roi_badge_gray");
      noteEl.style.display = "none";
    } else {
      paybackEl.textContent = paybackHarvests.toFixed(1) + " harvests (" + Math.ceil(paybackMonths) + " mo)";
      if (paybackMonths <= 12) {
        paybackEl.classList.add("tlw_roi_badge_green");
      } else {
        paybackEl.classList.add("tlw_roi_badge_yellow");
      }

      // Note
      if (paybackMonths <= 6) {
        noteEl.textContent = "\u2713 Pays for itself in under 6 months";
        noteEl.style.display = "block";
      } else if (paybackMonths <= 12) {
        noteEl.textContent = "\u2713 Pays for itself in under a year";
        noteEl.style.display = "block";
      } else {
        noteEl.style.display = "none";
      }
    }
  }

  for (var j = 0; j < ids.length; j++) {
    els[ids[j]].addEventListener("input", calculate);
  }

  calculate();
})();


/* Widget: vpd-chart */
(function(){
"use strict";
var vD=document.getElementById("tlw_vpd_val"),rS=document.getElementById("tlw_vpd_rh"),aS=document.getElementById("tlw_vpd_at"),lS=document.getElementById("tlw_vpd_lt"),
rV=document.getElementById("tlw_vpd_rh_v"),aV=document.getElementById("tlw_vpd_at_v"),lV=document.getElementById("tlw_vpd_lt_v"),
cD=document.getElementById("tlw_vpd_chart"),lU=document.getElementById("tlw_vpd_leg_ul"),
uR=document.querySelectorAll('input[name="tlw_vpd_unit"]');
if(!cD||!rS||!aS||!lS)return;

function svp(t){return 610.78*Math.exp(t/(t+238.3)*17.2694)}
function calcVpd(rh,atC,ltC){var sL=svp(ltC),sA=svp(atC),aA=(rh/100)*sA;return(sL-aA)/1000}
function f2c(f){return(f-32)*5/9}function c2f(c){return c*9/5+32}
function gu(){return document.querySelector('input[name="tlw_vpd_unit"]:checked').value}

var Z=[{n:"Too Low",lo:-99,hi:0.4,c:"CadetBlue",d:"< 0.4 kPa (Mold risk)"},
{n:"Clones/Seedlings",lo:0.4,hi:0.8,c:"Khaki",d:"0.4-0.8 kPa (Clones/Seedlings)"},
{n:"Late Veg/Early Flower",lo:0.8,hi:1.2,c:"DarkSeaGreen",d:"0.8-1.2 kPa (Late Veg/Early Flower)"},
{n:"Mid/Late Flower",lo:1.2,hi:1.6,c:"RosyBrown",d:"1.2-1.6 kPa (Mid/Late Flower)"},
{n:"Too High",lo:1.6,hi:99,c:"SlateGray",d:"> 1.6 kPa (Plant stress)"}];
var MN=0,MX=3;

function gz(v){for(var i=0;i<Z.length;i++)if(v>=Z[i].lo&&v<Z[i].hi)return Z[i];return Z[Z.length-1]}

function mkCS(){var cs=[[0,gz(MN).c]],bs=new Set();
Z.forEach(function(z){if(z.lo>MN&&z.lo<MX)bs.add(z.lo);if(z.hi<MX&&z.hi>MN)bs.add(z.hi)});
Array.from(bs).sort(function(a,b){return a-b}).forEach(function(b){var n=(b-MN)/(MX-MN);if(n>0.001&&n<0.999){cs.push([n,gz(b-0.001).c]);cs.push([n,gz(b).c])}});
cs.push([1,gz(MX).c]);return cs}
var CS=mkCS();

function updDisp(){var u=gu();rV.textContent=rS.value+" %";aV.textContent=parseFloat(aS.value).toFixed(1)+" \u00B0"+u;lV.textContent=parseFloat(lS.value).toFixed(1)+" \u00B0"+u}

function updVPD(){var rh=parseFloat(rS.value),atD=parseFloat(aS.value),ltD=parseFloat(lS.value),u=gu();
var atC=u==="F"?f2c(atD):atD,ltC=u==="F"?f2c(ltD):ltD;
aS.dataset.c=atC.toFixed(3);lS.dataset.c=ltC.toFixed(3);
var v=calcVpd(rh,atC,ltC);vD.textContent=v.toFixed(2);
var ht=cD.data?cD.data.find(function(t){return t.type==="heatmap"}):null;
if(ht&&cD.layout)Plotly.react(cD,[ht,{x:[rh],y:[atD],type:"scatter",mode:"markers",marker:{color:"rgba(0,0,0,0.85)",size:13,symbol:"cross-thin",line:{width:2.5,color:"#fff"}},name:"Current",hoverinfo:"skip"}],cD.layout)}

function draw(){var u=gu(),m=window.innerWidth<600,tA=[],tL;
if(u==="C"){for(var t=0;t<=50;t++)tA.push(t);tL="Air Temp (\u00B0C)"}
else{for(var t2=32;t2<=122;t2+=2)tA.push(t2);tL="Air Temp (\u00B0F)"}
var rA=[];for(var r=0;r<=100;r+=5)rA.push(r);
var zD=[],hT=[];
for(var i=0;i<tA.length;i++){var aTC=u==="F"?f2c(tA[i]):tA[i],sA=svp(aTC),zR=[],hR=[];
for(var j=0;j<rA.length;j++){var v=0;if(sA>0){v=(sA-(rA[j]/100)*sA)/1000;if(isNaN(v))v=0}
zR.push(v);hR.push("Temp: "+tA[i].toFixed(1)+"\u00B0"+u+"<br>RH: "+rA[j]+"%<br>VPD: "+v.toFixed(2)+" kPa<br>Zone: "+gz(v).n)}
zD.push(zR);hT.push(hR)}
var tv=[],tt=[];Z.forEach(function(z){var lo=Math.max(MN,z.lo<-10?MN:z.lo),hi=Math.min(MX,z.hi>10?MX:z.hi);if(hi>lo){tv.push((lo+hi)/2);tt.push(z.n)}});
var tr={x:rA,y:tA,z:zD,text:hT,type:"heatmap",hoverinfo:"text",colorscale:CS,zmin:MN,zmax:MX,
colorbar:{title:"VPD",titleside:"right",tickvals:tv,ticktext:tt,len:m?0.9:0.85,thickness:m?15:20,tickfont:{size:m?8:10},titlefont:{size:m?10:12}}};
var ly={title:m?"VPD Chart":"Vapor Pressure Deficit Chart",
xaxis:{title:m?"RH (%)":"Relative Humidity (%)",range:[0,100],fixedrange:true,tickmode:"linear",tick0:0,dtick:m?20:10,automargin:true,tickfont:{size:m?9:10}},
yaxis:{title:tL,range:u==="C"?[0,50]:[32,122],fixedrange:true,automargin:true,tickfont:{size:m?9:10}},
margin:{l:m?55:70,r:m?40:50,b:m?55:80,t:m?35:50,pad:4},plot_bgcolor:"rgba(0,0,0,0)",paper_bgcolor:"rgba(0,0,0,0)"};
Plotly.newPlot(cD,[tr],ly,{responsive:true,displayModeBar:false});updVPD();
if(!cD._tlClick){cD.on("plotly_click",function(d){if(d.points&&d.points.length){var p=d.points[0],rh=parseFloat(p.x),at=parseFloat(p.y),u2=gu(),atC=u2==="F"?f2c(at):at;
rS.value=rh.toFixed(0);var ltC=atC-2;
if(u2==="C"){aS.value=atC.toFixed(1);lS.value=ltC.toFixed(1)}else{aS.value=c2f(atC).toFixed(1);lS.value=c2f(ltC).toFixed(1)}
aS.dataset.c=atC.toFixed(3);lS.dataset.c=ltC.toFixed(3);updDisp();updVPD()}});cD._tlClick=true}}

function mkLeg(){if(!lU)return;lU.textContent="";Z.forEach(function(z){var li=document.createElement("li"),b=document.createElement("div"),s=document.createElement("span");
b.className="tlw_vpd_cbox";b.style.backgroundColor=z.c;s.textContent=z.d;li.appendChild(b);li.appendChild(s);lU.appendChild(li)})}

function chgUnit(){var u=gu(),aC=parseFloat(aS.dataset.c)||25,lC=parseFloat(lS.dataset.c)||23;
if(u==="C"){aS.min="0";aS.max="50";lS.min="0";lS.max="50";aS.value=aC.toFixed(1);lS.value=lC.toFixed(1)}
else{aS.min="32";aS.max="122";lS.min="32";lS.max="122";aS.value=c2f(aC).toFixed(1);lS.value=c2f(lC).toFixed(1)}
updDisp();draw()}

rS.addEventListener("input",function(){updDisp();updVPD()});
aS.addEventListener("input",function(){updDisp();updVPD()});
lS.addEventListener("input",function(){updDisp();updVPD()});
uR.forEach(function(r){r.addEventListener("change",chgUnit)});

aS.dataset.c="25";lS.dataset.c="23";updDisp();draw();mkLeg();
var rt;window.addEventListener("resize",function(){clearTimeout(rt);rt=setTimeout(function(){if(document.getElementById("tlw_vpd_chart"))draw()},250)});
})();
